import React, {Component} from 'react';
import {Button, Card, CardBody, CardFooter, Col, Form, FormGroup, FormText, Input, Label, Row} from 'reactstrap';
import UserService from "../../services/UserService";
import userSelfService from "../../services/UserSelfService";

import SweetAlert from 'react-bootstrap-sweetalert';
import {toast, ToastContainer} from 'react-toastify';
import ResetPasswordModal from "../../pages/auth/ResetPasswordModal";
import {handleErrorMessage} from "../../services/CommonService";

export default class CustomerProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            isSuccess: false,
            formErrors: {},
            disabled: true,
            isEditing: false,
            showAlert: false,
            basicTitle: '',
            basicType: "default",
            msg: "",
            openResetPasswordModel: false,
            clearResetPasswordModel: false,
            loading: {
                updatePassword: false
            }

        };

        this.userService = new UserService();

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
        this.refresh = this.refresh.bind(this);
        this.updatePassword = this.updatePassword.bind(this);

        this.toggleOpenResetPasswordModal = this.toggleOpenResetPasswordModal.bind(this);
        this.toggleClearResetPasswordModal = this.toggleClearResetPasswordModal.bind(this);
    }

    componentDidMount() {
        this.userService.getUserDetail().then(response => {
            let user = response.data;
            this.setState({user});
        }).catch(error => {
            toast.error(handleErrorMessage(error), { position: toast.POSITION.BOTTOM_CENTER });
        })
    }


    closeAlert() {
        this.setState({showAlert: false})
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let user = {...this.state.user};
        user[name] = value;
        this.setState({user: user});
    }

    validateForm() {

        let formErrors = {};
        let uv = this.state.user.username.trim().length >= 3;
        let fnv = this.state.user.firstName.trim().length > 1;
        let lnv = this.state.user.lastName.trim().length > 1;
        let emv = this.state.user.emailAddress.trim().length > 3;
        if (!uv) formErrors.username = "Input valid username";
        if (!fnv) formErrors.firstName = "Input valid firstname";
        if (!lnv) formErrors.lastName = "Input valid lastname";
        if (!emv) formErrors.emailAddress = "Input valid email";

        return {valid: uv && fnv && lnv && emv, formErrors: formErrors};
    }

    handleEdit() {
        if (!this.state.isEditing) {
            this.setState({disabled: false, isEditing: true});
        } else {
            this.setState({disabled: true, isEditing: false});
            this.userService.getUser().then(data => {
                this.setState({user: data})
            })
        }

    }

    async handleSubmit(event) {
        event.preventDefault();

        let result = this.validateForm();
        if (!result.valid) {
            this.setState({formErrors: result.formErrors});
            return;
        }

        const user = {
            id: this.state.user.userId,
            firstname: this.state.user.firstName,
            lastname: this.state.user.lastName,
            phoneNumber: this.state.user.phoneNumber,
            email: this.state.user.emailAddress,
            userCategory: this.state.user.userCategory,
            username:this.state.user.username
        };

        userSelfService.updateProfile(user).then(response => {
            this.setState({
                showAlert: true,
                basicType: 'success',
                basicTitle: 'Successfully Saved!',
                msg: "Success",
                formErrors: {},
                isEditing: false,
                disabled: true,
                user: response.data
            });
            this.refresh();
        }, error => {
            this.setState({showAlert: true, basicType: 'danger', basicTitle: 'Error', msg: handleErrorMessage(error)});
        });

    }

    updatePassword(password, repassword) {
        let {loading} = this.state;

        loading.updatePassword = true;
        this.setState({loading});
        userSelfService.updatePassword(password, repassword).then(response => {
            toast.success("Password updated!", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            loading.updatePassword = false;
            this.setState({loading});
            this.toggleOpenResetPasswordModal(false);
        }).catch(error => {
            console.log(error);
            toast.error(handleErrorMessage(error), {
                position: toast.POSITION.BOTTOM_CENTER
            });
            loading.updatePassword = true;
            this.setState({loading});
        });

    }

    refresh() {
        const user = this.state.user;
        this.userService.getUser().then(data => {
            data.firstName = user.firstName;
            data.lastName = user.lastName;
            data.phoneNumber = user.phoneNumber;
            data.emailAddress = user.emailAddress;
            localStorage.setItem("user", JSON.stringify(data));
        })
    }


    toggleOpenResetPasswordModal(change) {
        let {clearResetPasswordModel} = this.state;
        if (!change) {
            clearResetPasswordModel = true;
        }
        this.setState({openResetPasswordModel: change, clearResetPasswordModel});
    }

    toggleClearResetPasswordModal(change) {
        this.setState({clearResetPasswordModel: change});
    }


    render() {
        let {user, formErrors, disabled, isEditing, openResetPasswordModel, clearResetPasswordModel, loading} = this.state;
        user.email = user.emailAddress;

        return (
            <div>

                <div className={"text-center"}>
                    <h4 className="display-4">Personal info</h4>
                    <p>Basic info, like your name and contact details, that you use with us.</p>
                </div>
                <Row>

                    <Col xs={12} sm={12} md={8} lg={8} xl={6}>
                        <Form onSubmit={this.handleSubmit}>
                            <Card>
                                <CardBody>
                                    <h5 className={"mb-3"}>Profile</h5>
                                    <Row>
                                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label for="firstName">First name</Label>
                                                <Input text="" name="firstName" id="firstName"
                                                       value={user.firstName || ''}
                                                       onChange={this.handleChange} disabled={disabled}/>
                                                <FormText>{formErrors.firstName}</FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <FormGroup>
                                                <Label for="lastName">Last name</Label>
                                                <Input text="" name="lastName" id="lastName" value={user.lastName || ''}
                                                       onChange={this.handleChange} disabled={disabled}/>
                                                <FormText>{formErrors.lastName}</FormText>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <FormGroup>
                                        <Label for="phoneNumber">Phone</Label>
                                        <Input text="" name="phoneNumber" id="phoneNumber"
                                               value={user.phoneNumber || ''}
                                               onChange={this.handleChange} disabled={disabled}/>
                                        <FormText>{formErrors.phoneNumber}</FormText>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="emailAddress">Email</Label>
                                        <Input text="" type="email" name="emailAddress" id="emailAddress"
                                               value={user.emailAddress || ''} onChange={this.handleChange}
                                               disabled/>
                                        <FormText>{formErrors.email}</FormText>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="username">Username
                                            <small
                                                className={"text-muted"}>{' '}(auto-generated)
                                            </small>
                                        </Label>
                                        <Input text="" name="username" id="username" value={user.username || ''}
                                               onChange={this.handleChange} disabled/>
                                        <FormText>{formErrors.username}</FormText>
                                    </FormGroup>
                                </CardBody>
                                <CardFooter>
                                    <div className="text-right">
                                        <Button color={isEditing ? "secondary" : "primary"}
                                                onClick={this.handleEdit}><i
                                            className={isEditing ? "fa fa-times" : "fa fa-pencil"}/> &nbsp;{isEditing ? "Cancel" : "Edit"}
                                        </Button><span>&nbsp;&nbsp;</span>
                                        {isEditing ? <Button color="primary"
                                                             type="submit"><i className="fa fa-floppy-o"/>&nbsp;Save
                                        </Button> : null}
                                    </div>
                                </CardFooter>
                            </Card>
                        </Form>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={6}>
                        <Card>
                            <CardBody>
                                <h5 className={"mb-4"}>Security</h5>
                                <div className={"text-center"}>
                                    <Button block={true} color={"primary"}
                                            onClick={() => this.toggleOpenResetPasswordModal(true)}>Change
                                        Password</Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <ResetPasswordModal
                    user={user}
                    isOpen={openResetPasswordModel}
                    toggleModel={this.toggleOpenResetPasswordModal}
                    toggleClear={this.toggleClearResetPasswordModal}
                    updatePassword={this.updatePassword}
                    loading={loading.updatePassword}
                    clear={clearResetPasswordModel}
                />
                <SweetAlert show={this.state.showAlert} type={this.state.basicType} title={this.state.basicTitle}
                            onConfirm={this.closeAlert}> {this.state.msg} </SweetAlert>
                <ToastContainer/>
            </div>
        );

    }

}
